import uuid from 'uuid/v4';
import DesignBuilderContainer from './DesignBuilderContainer';
import cookiesFactory from '../../../../../base/cookies-factory';

export default class DesignBuilderPayload {
  constructor(estimate, containers, items) {
    const dbContainers = containers
      .map(givenContainer => new DesignBuilderContainer(givenContainer));

    const isInternalUser = cookiesFactory.isInternalUser();
    const originValue = isInternalUser ? 'CEC' : 'Online';

    this.designId = estimate.designId;
    this.name = estimate.name;
    this.productLine = 1;
    this.containers = dbContainers;
    this.items = items;
    this.zipCode = '';
    this.promoCode = '';
    this.subtotal = 0.0;
    this.isDeleted = false;
    this.agreementNumber = null;
    this.designAttributes = [{
      designAttributeId: uuid(),
      designId: estimate.designId,
      name: 'Origin',
      value: originValue,
    }];
  }
}
